import { SearchQuery } from 'modules/domains';
import { useRootQuery } from './useRootQuery';
import { SetRootQueryFn, useSetRootQuery } from './useSetRootQuery';

export const useRootQueryState = (): [state: SearchQuery, setterFn: SetRootQueryFn] => {
  const rootQuery = useRootQuery();
  const setRootQuery = useSetRootQuery();
  return [rootQuery, setRootQuery];
};
